import React, { useEffect, useMemo, useState } from "react";
import api from "../services/api";

function AddLesson({ setPage }) {

const [title,setTitle] = useState("");
const [description,setDescription] = useState("");
const [courseId,setCourseId] = useState("");
const [moduleId,setModuleId] = useState("");

const [hlsLink,setHlsLink] = useState("");
const [homeServerLink,setHomeServerLink] = useState("");

const [status,setStatus] = useState("");

const [documentFile,setDocumentFile] = useState(null);
const [allowDownload,setAllowDownload] = useState(false);

const [courses,setCourses] = useState([]);
const [modules,setModules] = useState([]);

const [loading,setLoading] = useState(false);

useEffect(()=>{
loadCourses();
loadModules();
},[]);

/* LOAD COURSES */

const loadCourses = async ()=>{
try{
const res = await api.get("/courses");
setCourses(res.data.data || []);
}catch(err){
console.log(err);
}
};

/* LOAD MODULES */

const loadModules = async ()=>{
try{
const res = await api.get("/modules");
setModules(res.data.data || []);
}catch(err){
console.log(err);
}
};

/* FILTER MODULES BASED ON COURSE */

const visibleModules = useMemo(()=>{
if(!courseId) return [];
return modules.filter((m)=>String(m.course_id) === String(courseId));
},[modules,courseId]);

/* RESET FORM */

const resetForm = ()=>{
setTitle("");
setDescription("");
setCourseId("");
setModuleId("");
setHlsLink("");
setHomeServerLink("");
setStatus("");
setDocumentFile(null);
setAllowDownload(false);
};

/* SAVE LESSON */

const saveLesson = async(mode)=>{

if(!title || !moduleId){
alert("Title and Module required");
return;
}

/* require either bunny or home server */

if(!hlsLink && !homeServerLink){
alert("Provide either Bunny CDN link OR Home Server link");
return;
}

try{

setLoading(true);

/* IF FILE EXISTS → USE FORMDATA */

if(documentFile){

const formData = new FormData();

formData.append("title",title);
formData.append("description",description);
formData.append("module_id",String(moduleId));
formData.append("hls_video_url",hlsLink);
formData.append("home_server_url",homeServerLink);
formData.append("status",status);
formData.append("document",documentFile);
formData.append("allow_download",allowDownload);

await api.post("/lessons",formData,{
headers:{ "Content-Type":"multipart/form-data" }
});

}

/* NO FILE → USE JSON */

else{

await api.post("/lessons",{
title,
description,
module_id: moduleId,
hls_video_url: hlsLink,
home_server_url: homeServerLink,
status,
allow_download: allowDownload
});

}

/* SUCCESS */

if(mode==="close"){
alert("Lesson created successfully");
setPage({page:"lessons"});
return;
}

if(mode==="new"){
alert("Lesson created successfully");
resetForm();
}

}catch(err){

console.log(err.response?.data || err);

alert(err.response?.data?.message || "Failed to create lesson");

}finally{
setLoading(false);
}

};



return(

<div style={{padding:"30px",maxWidth:"900px"}}>

<h2 style={{marginBottom:"25px"}}>New Lesson Video</h2>

<div style={card}>

{/* TITLE */}

<div style={field}>
<label>Title *</label>
<input
style={input}
value={title}
onChange={(e)=>setTitle(e.target.value)}
/>
</div>

{/* DESCRIPTION */}

<div style={field}>
<label>Description</label>
<textarea
style={textarea}
value={description}
onChange={(e)=>setDescription(e.target.value)}
/>
</div>

{/* COURSE */}

<div style={field}>
<label>Course *</label>

<select
style={input}
value={courseId}
onChange={(e)=>{
  const selectedCourse = e.target.value;

  setCourseId(selectedCourse);

  // ✅ Only reset if module does not belong to new course
  if (!visibleModules.find(m => String(m.id) === String(moduleId))) {
    setModuleId("");
  }
}}
>

<option value="">Select Course</option>

{courses.map((c)=>(
<option key={c.id} value={c.id}>
{c.title}
</option>
))}

</select>

</div>

{/* MODULE */}

<div style={field}>
<label>Module (Topic) *</label>

<select
style={input}
value={moduleId}
onChange={(e)=>setModuleId(e.target.value)}
disabled={!courseId}
>

<option value="">Select Module</option>

{visibleModules.map((m)=>(
<option key={m.id} value={m.id}>
{m.title}
</option>
))}

</select>

</div>

{/* BUNNY CDN */}

<div style={field}>
<label>Bunny CDN Link (HLS)</label>
<input
style={input}
value={hlsLink}
onChange={(e)=>setHlsLink(e.target.value)}
placeholder="https://bunnycdn.com/..."
/>
</div>

{/* HOME SERVER */}

<div style={field}>
<label>MaAz Server Video Link</label>
<input
style={input}
value={homeServerLink}
onChange={(e)=>setHomeServerLink(e.target.value)}
placeholder="https://jta.jackstechnologies.com/..."
/>
</div>

{/* DOCUMENT */}

<div style={field}>

<label>Attach Document (Optional)</label>

<input
type="file"
onChange={(e)=>setDocumentFile(e.target.files[0])}
/>

<div style={{marginTop:"10px"}}>

<label>

<input
type="checkbox"
checked={allowDownload}
onChange={()=>setAllowDownload(!allowDownload)}
/>

{" "}Allow Students To Download

</label>

</div>

</div>

{/* STATUS */}

<div style={field}>
<label>Status *</label>

<select
style={input}
value={status}
onChange={(e)=>setStatus(e.target.value)}
>

<option value="">Select Status</option>
<option value="draft">Draft</option>
<option value="published">Published</option>
<option value="archived">Archived</option>

</select>

</div>

</div>

{/* BUTTONS */}

<div style={{marginTop:"20px"}}>

<button
style={primaryBtn}
onClick={()=>saveLesson("close")}
disabled={loading}
>
{loading ? "Saving..." : "Save & Close"}
</button>

<button
style={successBtn}
onClick={()=>saveLesson("new")}
disabled={loading}
>
{loading ? "Saving..." : "Save & Create New"}
</button>

<button
style={cancelBtn}
onClick={()=>setPage({page:"lessons"})}
>
Cancel
</button>

</div>

</div>

);

}

/* ---------- UI ---------- */

const card={
background:"#fff",
padding:"25px",
borderRadius:"8px",
boxShadow:"0 2px 10px rgba(0,0,0,0.08)"
};

const field={
marginBottom:"18px"
};

const input={
width:"100%",
padding:"10px",
border:"1px solid #ddd",
borderRadius:"6px"
};

const textarea={
width:"100%",
height:"120px",
padding:"10px",
border:"1px solid #ddd",
borderRadius:"6px"
};

const primaryBtn={
background:"#2c3e50",
color:"white",
padding:"10px 18px",
border:"none",
borderRadius:"6px",
marginRight:"10px",
cursor:"pointer"
};

const successBtn={
background:"#1f7a5c",
color:"white",
padding:"10px 18px",
border:"none",
borderRadius:"6px",
marginRight:"10px",
cursor:"pointer"
};

const cancelBtn={
padding:"10px 18px",
borderRadius:"6px",
border:"1px solid #ccc",
cursor:"pointer"
};

export default AddLesson;